export const CLOSE_REASONS = {
  CLICK_AWAY: 'clickAway',
  CLICK_ANCHOR: 'clickAnchor',
  ESC: 'esc',
  OFF_SCREEN: 'offScreen',
}

export const PADDING_CLASSES = {
  default: 'p-x p-y-xs',
  none: '',
  medium: 'p-x-md p-y-xs',
}

export const MODAL_IGNORE_ATTRIBUTE = 'data-custom-ignore'
